import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  Col,
  FloatingLabel,
  Form,
  Modal,
  Row,
  Table,
} from "react-bootstrap";
import { getPhonepeRefund, getRefundList } from "../../services/authServices";
import moment from "moment";
import Swal from "sweetalert2";
import { SuccessTost } from "../../components/tostpop/tostPop";
import MainTitle from "../../components/mainTitile/mainTitle";
import TablePagination from "../../components/pagination/tablePagination";

const RefundComp = () => {
  const [refundList, setrefundList] = useState([]);
  const [refundListdata, setRefundListdata] = useState([]);
  const [singleDataAMendmentId, setSingleDataAMendmentId] = useState("");

  const [isdisable, setIsdisable] = useState(true);
  const [isSuccess, setIsSuccess] = useState(true);
  const [refundDetails, setRefundDetails] = useState({
  remark:'',
  amount: ''
  });
  console.warn('refun data form',refundDetails);


  // pagination for reund list

  
  const [pageCount, setPageCount] = useState(0);
  const [pageData, setPageData] = useState(10);
  const [page, setPage] = useState(1);

  useEffect(() => {
    getRefundData()
  }, [page, pageData]);

  useEffect(() => {
    const pagedatacount = Math.ceil(pageCount / pageData);
    setPageCount(pagedatacount);
  }, [refundListdata]);

  const handleRowSize = (e) => {
    const { innerHTML } = e.target;
    setPageData(innerHTML);
    console.log("row per page size", innerHTML);
  };

  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
    getRefundData();
  };
  const handleFunds = (e) =>{
    const { name ,value} = e.target;
    console.warn('refun data form',name ,value,e);
    setRefundDetails({...refundDetails, [name] : value})
  }
  const handleCancellation = () =>{
    let params = {
    tmt_orderId : refundList?.tmt_order_id,
    amount: refundDetails.amount,
    refund_remark : refundDetails.remark,
    amendmentId : refundList?.amendmentId
    }
    console.log('amendment id here',refundList?.amendmentId);
    getPhonepeRefund(params).then((res)=>{
      SuccessTost(res.data.message)
      handleClose()
    console.warn('refund api response',res);
  }).catch((err)=>{
    console.warn('refund api error',err);
    
    })
  }

  const handleShow = () => setShow(true);
  const handleSingleData = (data) => {
    let id = data.amendmentId;
    const params = {
      flow: "single",
      amendmentId: id,
    };
    setShow(true);
    getRefundListDetails(params);
  };
  const getRefundListDetails = (data) => {
    getRefundList(data)
      .then((res) => {
        console.log('single order data here',res);
        setrefundList(res?.data?.Data);
        

      })
      .catch((err) => {
        console.error(err);
      });
  };
  const getRefundData = () => {
    const params = {
      flow: "all", 
    };
    let pagignation ={
      page ,
      limit : pageData,
    }
    getRefundList(params,pagignation)
      .then((res) => {
        setRefundListdata(res?.data?.Data?.refundData);
        setPageCount(res?.data?.Data?.totalCount)
        console.warn('refund list data',res?.data?.Data?.totalCount);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleConfirm = () => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: "Are you sure?",
        text: "Do you really want to approved the request for refund.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Approve!",
        cancelButtonText: "No, Cancel!",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          swalWithBootstrapButtons.fire({
            title: "Approved",
            text: "You have approved the request for refund of $Amount.",
            icon: "success",
          }).then((confirm)=>{
            if(confirm){
              handleCancellation()
            }
          });
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
          swalWithBootstrapButtons.fire({
            title: "Approval Cancelled.",
            text: "You have cancelled the request.",
            icon: "error",
          });
        }
      });
  };
  useEffect(() => {
    getRefundData();
    
  },[]);
  useEffect(()=>{
    if(refundDetails?.remark?.length > 4 && refundDetails.amount.length > 1 ){
      setIsdisable(false)
      }
  },[refundDetails])
  return (
    <>
    
          <Row>

<MainTitle heading={"Refund List"} textAlign={"center"} />
</Row>
<Row>
          {refundListdata?.length > 0 ? (
          <>
            <Table
              
              responsive
              bordered
              hover
              style={{ textAlign: "center" }}
            >
              <thead className="fs-14 fw-700">
                <tr>
                  <th>RedundID</th>
                  <th>AmendmentID</th>
                  <th>OrderID</th>
                  <th>UserID</th>
                  <th>TripjackID</th>
                  <th>Amendment Status</th>
                  <th>Refund Status</th>
                  <th>Refundable Amount</th>
                  <th>Action</th>
                </tr>
              </thead>
              {refundListdata?.map((i, k) => {
                return (
                  <>
                    <tbody className="fs-12">
                      <tr>
                        <td>{i?.refundId}</td>
                        <td>{i?.amendmentId}</td>
                        <td>{i?.tmt_order_id}</td>
                        <td>{i?.tmt_userId}</td>
                        <td>{i?.tripBookingId}</td>
                        <td>{i?.amendmentStatus}</td>
                        <td>{i?.refundStatus}</td>
                        <td>{i?.refundableAmount}</td>
                        <td>
                          <Button
                            onClick={() => handleSingleData(i)}
                            variant="warning"
                            disabled={i?.amendmentStatus === 'REJECTED' || i?.amendmentStatus === 'REQUESTED' ||  i?.amendmentStatus === 'PENDING' }
                          >
                            <b style={{ fontSize: "small" }}>Details</b>
                          </Button>
                        </td>
                      </tr>
                    </tbody>
                  </>
                );
              })}


            </Table>
               {pageCount > 1 &&


          <TablePagination handleRowSize={handleRowSize} setPage={setPage} page={page} pageData={pageData} pageCount={pageCount} />
                }
                </>
          ) : (
            <Card.Header
              className="mb-2"
              style={{ textAlign: "center", borderRadius: "5px" }}
            >
              <h5>No Records Found</h5>
            </Card.Header>
          )}
          </Row>
      
      <div
        className="modal show"
        style={{ display: "block", position: "initial" }}
      >
        <Modal
          show={show}
          onHide={handleShow}
          centered
          className="p-3"
          style={{ fontSize: "small" }}
          size="lg"
        >
          <Modal.Header>
            <Modal.Title>Refund Info</Modal.Title>{" "}
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col sm={6}>
                <Table striped>
                  <tbody>
                    <tr>
                      <th>Refund ID</th>
                      <td>:</td>
                      <td>
                        {refundList?.refundId === undefined
                          ? "NA"
                          : refundList?.refundId}
                      </td>
                    </tr>
                    <tr>
                      <th>Amend ID</th>
                      <td>:</td>
                      <td>
                        {refundList?.amendmentId === undefined
                          ? "NA"
                          : refundList?.amendmentId}
                      </td>
                    </tr>
                    <tr>
                      <th>Amendment Status</th>
                      <td>:</td>
                      <td>
                        {refundList?.amendmentStatus === undefined
                          ? "NA"
                          : refundList?.amendmentStatus}
                      </td>
                    </tr>
                    <tr>
                      <th>Refund Status</th>
                      <td>:</td>
                      <td>
                        {refundList?.refundStatus === undefined
                          ? "NA"
                          : refundList?.refundStatus}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
              <Col sm={6}>
                <Table striped>
                  <tbody>
                    <tr>
                      <th>Refundable Amount</th>
                      <td>:</td>
                      <td>
                        {refundList?.refundableAmount === undefined
                          ? "NA"
                          : refundList?.refundableAmount}
                      </td>
                    </tr>
                    <tr>
                      <th>TMT Order ID</th>
                      <td>:</td>
                      <td>
                        {refundList?.tmt_order_id === undefined
                          ? "NA"
                          : refundList?.tmt_order_id}
                      </td>
                    </tr>
                    <tr>
                      <th>TMT User ID</th>
                      <td>:</td>
                      <td>
                        {refundList?.tmt_userId === undefined
                          ? "NA"
                          : refundList?.tmt_userId}
                      </td>
                    </tr>
                    <tr>
                      <th>Tripjack BookingID</th>
                      <td>:</td>
                      <td>
                        {refundList?.tripBookingId === undefined
                          ? "NA"
                          : refundList?.tripBookingId}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
            <label className="mt-2">
              <h5>Trip Information</h5>
            </label>

            <Table striped>
              <thead>
                <tr>
                  <th>Source </th>
                  <th>Destination:</th>
                  <th>Depart Date</th>
                  <th>Airlines Name</th>
                  <th>Flight Number</th>
                </tr>
              </thead>
              <tbody>
                {refundList?.trips?.map((i, k) => {
                  return (
                    <tr key={k}>
                      <td>{i?.src}</td>
                      <td>{i?.dest}</td>
                      <td>{moment(i?.departureDate).format("DD-MM-YYYY")}</td>
                      <td>
                        {i?.airlines?.map((index, k) => {
                          return (
                            <Row className="mx-0" key={k}>
                              {k + 1}
                              {")"} {index}
                            </Row>
                          );
                        })}
                      </td>
                      <td>
                        {i?.flightNumbers?.map((index, k) => {
                          return (
                            <Row className="mx-0" key={k}>
                              {k + 1}
                              {")"} {index}
                            </Row>
                          );
                        })}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
            <label className="mt-2">
              <h5>Travellers Information</h5>
            </label>
            <Table striped>
              <thead>
                <tr>
                  <th>Traveller Name</th>
                  <th>Total Fare</th>
                  <th>Refundable Amount</th>
                  <th>Amendment Charges</th>
                </tr>
              </thead>
              <tbody>
                {refundList?.trips?.map((i, k) => {
                  return (
                    <tr>
                      {i?.travellers?.map((ind, k) => {
                        return (
                          <>
                            <td>{ind?.fn + " " + ind?.ln}</td>
                            <td>{ind?.totalFare}</td>
                            <td>{ind?.refundableamount}</td>
                            <td>{ind?.amendmentCharges}</td>
                          </>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>

      
            </Table>

            <Form>
              <Table striped>
                <thead>
                  <tr>
                    <td>
                      <FloatingLabel label={"Deduct Amount"}>
                        <Form.Control type="number" name="amount" value={refundDetails?.amount} onChange={(e)=>handleFunds(e)}/>
                      </FloatingLabel>
                    </td>
                    <td>
                      <FloatingLabel label={"Remarks"} className="mt-2">
                        <Form.Control type="text" name='remark' value={refundDetails?.remark} onChange={(e)=>handleFunds(e)}/>
                      </FloatingLabel>
                    </td>
                  </tr>
                 
                </thead>
              </Table>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cancel
            </Button>
            <Button type="submit" disabled={isdisable} variant="primary" onClick={handleConfirm}>
            Approved
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default RefundComp;
